import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {TabPanel, TabView} from 'primereact/tabview'
import {useMemo, useRef} from 'react'
import {useParams} from 'react-router-dom'
import {ReactComponent as OnWrist} from '../../assets/icons/OnWrist.svg'
import TranslateUtils from '../../i18n/TranslateUtils'
import GenericLogTable from '../generic-log/GenericLogTable'

const DeviceActivitiesLog = () => {
    useSignals()
    const {id: idString} = useParams()
    const id = useMemo(() => {
        if (!idString) {
            return null
        }
        return parseInt(idString)
    }, [idString])
    const {translateCommons} = TranslateUtils()
    const onWristLogRef = useRef(null)
    const batteryChargeRef = useRef(null)

    const activeIndex = useSignal(0)

    return (
        <div>
            <div className="flex mb-1 border-round justify-content-center align-items-center py-3 px-2 flex-wrap bg-teal-50 ">
                <h5
                    className={`pl-2 text-darkcyan font-bold w-full m-0 py-2 text-center md:text-left`}>
                    <span className="mr-3">
                        <OnWrist
                            style={{
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    </span>
                    {translateCommons('Device Activities')}
                </h5>
            </div>
            <TabView
                activeIndex={activeIndex.value}
                onTabChange={e => {
                    activeIndex.value = e.index
                }}>
                <TabPanel header={translateCommons('On-Wrist Logs')}>
                    <div
                        className={`col-12 m-0  p-0 flex gap-2   flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                        <h5 className="m-0 text-base md:text-lg   text-700">
                            {translateCommons(
                                'The audit log shows various changes made when the patient is wearing the device. For example, it records when the patient puts on or takes off the device',
                            )}
                        </h5>
                        <div>
                            <Button
                                className="p-button-text audit-button gap-1 px-3 w-17rem"
                                icon="pi pi-download"
                                label={translateCommons(
                                    'Show Device Activity Log',
                                )}
                                onClick={() => {
                                    if (!!id) {
                                        onWristLogRef.current?.showForm({
                                            refId: id,
                                            type: 'onWristLog',
                                        })
                                    }
                                }}
                            />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={translateCommons('Battery Charge Logs')}>
                    <div
                        className={`col-12 m-0  p-0 flex gap-2 flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                        <h5 className="m-0 text-base md:text-lg text-700">
                            {translateCommons(
                                'The audit log shows various changes made when the device is charging. For example, it records when the device is charging or not charging',
                            )}
                        </h5>
                        <Button
                            className="p-button-text audit-button gap-1 px-3 "
                            icon="pi pi-download"
                            label={translateCommons('Show Device Activity Log')}
                            onClick={() => {
                                if (!!id) {
                                    batteryChargeRef.current?.showForm({
                                        refId: id,
                                        type: 'batteryChargeLog',
                                    })
                                }
                            }}
                        />
                    </div>
                </TabPanel>
            </TabView>

            <GenericLogTable ref={onWristLogRef} />
            <GenericLogTable ref={batteryChargeRef} />
        </div>
    )
}

export default DeviceActivitiesLog
